import script from "./ChartDistribucionCategoria.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartDistribucionCategoria.vue?vue&type=script&setup=true&lang=js"

import "./ChartDistribucionCategoria.vue?vue&type=style&index=0&id=1ef3e33c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ef3e33c"]])

export default __exports__